var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserEdit } from "Server/CommandMacros";
import { AddMapObject } from "Server/Commands/AddMapObject";
import { MapObject } from "Store/firebase/mapObjects/@MapObject";
import { Command, MergeDBUpdates, AssertValidate } from "mobx-firelink";
import { GenerateUUID } from "Utils/General/KeyGenerator";
let AddBook = class AddBook extends Command {
    Validate() {
        const { book } = this.payload;
        this.id = GenerateUUID();
        book.creator = this.userInfo.id;
        const newObject = new MapObject({ name: "World" });
        this.sub_addObject = new AddMapObject({ object: newObject, parentID: null });
        this.sub_addObject.Validate();
        book.rootMapObject = this.sub_addObject.id;
        AssertValidate(`Book`, book, `Book invalid`);
        this.returnData = this.id;
    }
    GetDBUpdates() {
        const { book } = this.payload;
        let updates = {};
        updates[`books/${this.id}`] = book;
        updates = MergeDBUpdates(updates, this.sub_addObject.GetDBUpdates());
        return updates;
    }
};
AddBook = __decorate([
    UserEdit
], AddBook);
export { AddBook };
